import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks on the Posting a Shift tutorial on the Help page
 * Event: dental_portal:help:shift_request_tutorial_clicked
 */
export function fireHelpShiftRequestTutorialClicked(): void {
  PosthogService.getInstance().track('dental_portal:help:shift_request_tutorial_clicked');
}
